module.exports = __webpack_public_path__ + "img/guess-game-mockup.2307d3bd.jpg";